export default "__VITE_ASSET__07e9f0de__"